<template>
    <div ref="chartdiv" class="chart" style="width: 100%; height: 100%"></div>
</template>
<script setup>
import { ref, onMounted, defineProps } from 'vue';
import * as am5 from '@amcharts/amcharts5';
import * as am5percent from '@amcharts/amcharts5/percent';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

onMounted(() => printChartData(props));

const chartdiv = ref(null);
const props = defineProps({
    LiteratureData: [],
    NonLiteratureData: [],
});
let root;
let chart;
let series;
let legend;
const printChartData = (res) => {
    //2023-01-01 pby 재반영 확인
    root = am5.Root.new(chartdiv?.value);
    root.setThemes([am5themes_Animated.new(root)]);
    chart = root.container.children.push(
        am5percent.PieChart.new(root, {
            layout: root.horizontalLayout,
            radius: am5.percent(70),
            innerRadius: am5.percent(50),
        }),
    );
    //2023-01-01 pby 재반영 확인
    series = chart.series.push(
        am5percent.PieSeries.new(root, {
            name: 'Series',
            categoryField: 'name',
            valueField: 'percent',
            legendLabelText: '[{fill}]{category}[/]',
            legendValueText: '',
        }),
    );
    series.get('colors').set('colors', [am5.color('#bee8c9'), am5.color('#77d87f'), am5.color('#18b73f')]);

    if (res.LiteratureData !== undefined) {
        series.data.setAll(res.LiteratureData);
    }
    //2023-01-01 pby 재반영 확인
    if (res.NonLiteratureData !== undefined) {
        series.data.setAll(res.NonLiteratureData);
    }
    //2023-01-01 pby 재반영 확인
    series.labels.template.set('forceHidden', true);
    series.ticks.template.set('forceHidden', true);
    legend = chart.children.push(
        am5.Legend.new(root, {
            centery: am5.percent(50),
            y: am5.percent(50),
            layout: root.verticalLayout,
        }),
    );
    //2023-01-01 pby 재반영 확인
    legend.labels.template.setAll({
        oversizedBehavior: 'wrap',
    });

    legend.valueLabels.template.setAll({
        textAlign: 'left',
    });

    series.bullets.push(function () {
        return am5.Bullet.new(root, {
            sprite: am5.Label.new(root, {
                text: "[fontWeight:700]{percent.formatNumber('#.')}%",
                categoryField: 'name',
                valueField: 'percent',
                fill: '#FFFFFF',
                dy: -20,
                dx: -20,
                populateText: true,
            }),
        });
    });
    //2023-01-01 pby 재반영 확인
    legend.data.setAll(series.dataItems);
    series.appear(1000, 100);
};
</script>
<style lang="scss" scoped>
@media print {
    .chart {
        ::v-deep > div {
            display: flex;
            justify-content: center;
        }
        ::v-deep canvas {
            width: 100% !important;
            height: 100% !important;
            top: 50% !important;
            left: 50% !important;
            transform: translate(-50%, -50%);
        }
    }
}
</style>
